<template lang="pug">
.form-input-standard-user-waiter-receive-messages-function.w-100
  .content.d-flex.flex-row.align-items-center
    span.error-message 詳細設定は受信メッセージを使用可にしないと有効になりません。

  //- 履歴閲覧の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("showMessages") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.showMessages")
  //- 返信の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getFunctionName("useReply") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useReply")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { WaiterReceiveMessagesFunction, waiterReceiveMessagesFunctionNameMap } from "@/commons/services/Authorization";

import UsableFunctionSwitch from "@/pc/basics/UsableFunctionSwitch.vue";

/**
 * ### 一般ユーザーの使用機能選択コンポーネント(待機者サービス、受信メッセージ)
 */
@Component({
  components: {
    UsableFunctionSwitch
  }
})
export default class FormInputStandardUserWaiterReceiveMessagesFunction extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: WaiterReceiveMessagesFunction;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): WaiterReceiveMessagesFunction {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: WaiterReceiveMessagesFunction) {
    this.$emit("input", newValue);
    return;
  }

  /**
   * ### メッセージ送信の項目名を返す
   */
  public getFunctionName(functionKeyName: string): string {
    const functionName: string | undefined = waiterReceiveMessagesFunctionNameMap.get(functionKeyName);
    return functionName ? functionName : "";
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.form-input-standard-user-waiter-receive-messages-function {
  margin-bottom: 12px;
  padding: 12px 12px 4px 12px;

  background-color: $hitomeq-gray;

  .content {
    margin-bottom: 8px;
    padding-right: 74px;

    .function-detail-name {
      margin-left: 16px;
    }
  }
}
</style>
